export class RecordUser {
    user_id?:number;
    username?:string;
    imageUrl?:string;
    record_id?:string;
    can_read?:string;
    can_write?:string;  

    constructor(init?:Partial<RecordUser>) {
        Object.assign(this, init);
    }
}